import SimpleFloatingEdge from './SimpleFloatingEdge';


const edgeTypes = {
  floating: SimpleFloatingEdge,
  
}

export default edgeTypes;